import axios from "axios";
import auth from "@/utils/auth";
import store from "@/store";
import router from "@/router";
import api from "@/api";
import qs from "qs";
import jwt_decode from "jwt-decode";
import { Loading, Message, MessageBox } from "element-ui";

const $axios = axios.create({
    timeout: 60 * 1000,
    baseURL: process.env.VUE_APP_BASE_API,
    responseType: "json",
    isRetryRequest: false,
});
const toLogin = () => {
    if (auth.getToken() !== null) {
        auth.removeToken();
    }
    const currentPageUrl = window.location.href;
    if (currentPageUrl.includes("/booksDetail")) {
        const bookUrl = currentPageUrl.substring(currentPageUrl.indexOf("/booksDetail?"), currentPageUrl.length);
        window.location.href = "/login?redirect=" + bookUrl;
    } else {
        window.location.href = '/login';
    }
};

// 在全局请求和响应拦截器中添加请求状态
let loading = null;

// request拦截器
$axios.interceptors.request.use(
    (config) => {
        if (!(config.data && config.data.hideLoading)) {
            loading = Loading.service({
                text: "拼命加载中",
                spinner: "el-icon-loading",
                background: "rgba(255, 255, 255, .7)",
            });
        }
        // 每次请求前判断是否存在token
        // 如果存在则统一在http请求的header中加上token
        const token = auth.getToken();
        if (token) {
            config.headers.MhUserAuthorization = `${token}`;
            // config.headers["Content-type"] = "application/json;charset=UTF-8"
        }
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

// respone拦截器
//用于拦截code != 1 的响应数据
$axios.interceptors.response.use(
    (response) => {
        //debugger
        if (loading) {
            loading.close();
        }
        //续命
        if (response.headers.etime < 1) { //刷新token
            api.login.GetRefreshToken().then((res) => {
                if (res.data.code != 1) {
                   // console.log(res.data.info);
                    return;
                }
                auth.setToken(res.data.token);
            })
        }
        if (response.data.code > -31 && response.data.code < -20) {
            // 约定登录超时状态码
            toLogin();
        } else {
            return response;
        }
    },
    (error) => {
        let showMessage = true;
        if (loading) {
            loading.close();
        }
        if (error && error.response) {
            if (error.response.code === -1) {
                showMessage = false;
                toLogin();
            } else {
                error.message = `请求出错（${error.response.status}）!`;
            }
        } else {
            // 请求超时或者网络有问题
            if (error.message.includes("timeout")) {
                error.message = "请求超时！请检查网络是否正常";
            } else {
                error.message = "请求失败，请检查网络是否已连接";
            }
        }
        if (showMessage) {
            Message({
                message: error.message,
                type: "error",
                duration: 3 * 1000,
            });
        }
        return Promise.reject(error);
    }
);
export default {
    $axios,
    post(url, data, config = {}) {
        return $axios({
            method: "post",
            url,
            data: data,
            ...config,
        });
    },
    post1(url, params) {
        return $axios({
            method: "post",
            url,
            data: qs.stringify(params),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            responseType: "blob",
        });
    },
    post2(url, params) {
        return $axios({
            method: "post",
            url,
            data: params,
            headers: {
                "Content-Type": "application/json;charset=utf-8",
            },
            responseType: "blob",
        });
    },
    post3(url, data) {
        return $axios({
            method: "post",
            url,
            data: data,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    post4(url, params) {
        return $axios({
            method: "post",
            url,
            data: qs.stringify(params),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    },
    get1(url, data) {
        return $axios({
            method: "get",
            url,
            data: data,
            headers: {
                "Content-Type": "application/json;charset=utf-8",
            },
            responseType: "blob",
        });
    },
    get2(url, data) {
        return $axios({
            method: "get",
            url,
            data: qs.stringify(data),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            responseType: "blob",
        });
    },
    get(url, params) {
        return $axios({
            method: "get",
            url,
            params,
            paramsSerializer: params => {
                return qs.stringify(params, { indices: false })
            },
        });
    },
    put(url, data) {
        return $axios({
            method: "put",
            url,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            data: data,

        });
    },
    put1(url, data) {
        return $axios({
            method: "put",
            url,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: qs.stringify(data),
        });
    },
    delete(url, data) {
        return $axios({
            method: "delete",
            url,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: qs.stringify(data),
        });
    },
};